import React from 'react';

import {
  AttacheCaseGrey,
  AttacheCaseWhite,
  LinkGrey,
  LinkWhite,
} from '@randstad-lean-mobile-factory/react-components-ui-shared';

import { MenuSection } from 'src/Components/MenuSection/MenuSection.types';

export const URL = 'custom-randy';
export const ICON = 'logoRandy192.png';
export const AGENDA_HELP_LINK =
  'https://docs.google.com/document/d/1KnwuP9OYVviJDkOxv1wslmDNteVFbd98UvIiQIuDjP8';
export const APPEL_MED_HELP_LINK =
  'https://docs.google.com/presentation/d/1kGreRGlis9MfFrI2VM-Q5dP3OFqet8-rP3eyv3RvXmQ';

export enum CustomRandySection {
  links = 'links',
}

export enum CustomRandySubSection {
  links = 'links',
  agency = 'agency',
}

export const AMBrand = 'AM';
export const AMSBrand = 'AMS';
export const JBMBrand = 'JBM';

export const availableBrands = new Set([AMBrand, AMSBrand, JBMBrand]);

export const menuItems: MenuSection<[CustomRandySection, CustomRandySubSection]>[] = [
  {
    title: 'liens personnalisés',
    item: CustomRandySection.links,
    items: [
      {
        title: 'liens',
        item: CustomRandySubSection.links,
        iconSelected: <LinkWhite />,
        iconNotSelected: <LinkGrey />,
      },
      {
        title: 'agence',
        item: CustomRandySubSection.agency,
        iconSelected: <AttacheCaseWhite />,
        iconNotSelected: <AttacheCaseGrey />,
      },
    ],
  },
];
